import {createContext, useContext} from "react";

export const AppShellContext = createContext({collapsed: false, toggle: () => {}, setPageTitle: () => {}});

export const useAppShell = () => useContext(AppShellContext);